// Documentos fiscais do Brasil (CPF e CNPJ), usados pelo cadastro de parceiros e da estrutura.

/** CPF: 11 números com os dois dígitos verificadores. */
export function isValidCpf(value: string): boolean {
  if (!/^\d{11}$/.test(value) || /^(\d)\1{10}$/.test(value)) return false;
  const digit = (len: number) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += Number(value[i]) * (len + 1 - i);
    const r = (sum * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return digit(9) === Number(value[9]) && digit(10) === Number(value[10]);
}

/**
 * CNPJ: 12 letras ou números e 2 dígitos verificadores. Vale o formato só numérico e o
 * alfanumérico da Receita Federal (julho de 2026): cada caractere conta como o código ASCII - 48.
 */
export function isValidCnpj(value: string): boolean {
  if (!/^[0-9A-Z]{12}\d{2}$/.test(value) || /^(\d)\1{13}$/.test(value)) return false;
  const digit = (len: number) => {
    const weights =
      len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < len; i++) sum += (value.charCodeAt(i) - 48) * weights[i]!;
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return digit(12) === Number(value[12]) && digit(13) === Number(value[13]);
}

/** Tira pontuação e espaços; letras em maiúsculas. É assim que o documento é guardado e buscado. */
export function normalizeTaxId(value: string): string {
  return value.toUpperCase().replace(/[^0-9A-Z]/g, '');
}
